import { useState, useEffect, useRef } from 'react';
import { SEARCH_DEBOUNCE_DELAY } from '../constants';


const useDebounce = (value, delay = SEARCH_DEBOUNCE_DELAY) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};


export const useDebouncedSearch = (searchFunction, delay = SEARCH_DEBOUNCE_DELAY) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const debouncedSearchTerm = useDebounce(searchTerm, delay);
  const searchFunctionRef = useRef(searchFunction);

  
  useEffect(() => {
    searchFunctionRef.current = searchFunction;
  }, [searchFunction]);

  useEffect(() => {
    if (debouncedSearchTerm !== searchTerm) {
      setIsSearching(true);
    }
  }, [searchTerm, debouncedSearchTerm]);

  useEffect(() => {
    if (debouncedSearchTerm || debouncedSearchTerm === '') {
      setIsSearching(false);
      if (searchFunctionRef.current) {
        searchFunctionRef.current(debouncedSearchTerm);
      }
    }
  }, [debouncedSearchTerm]); 

  const clearSearch = () => {
    setSearchTerm('');
  };

  return {
    searchTerm,
    setSearchTerm,
    debouncedSearchTerm,
    isSearching,
    clearSearch
  };
};



export default useDebounce;
